<template>
  <div class="template-form-compact">
    <div class="form-section">
      <h6 class="section-title">Радіус кута</h6>
      <div class="input-grid">
        <div class="input-group">
          <label for="p1">Вгорі ліворуч</label>
          <input id="p1" :class="{ 'red': detailValidation('P1_') }" @change="fixedLength(detail, 'p1')"
            v-model.number="detail.p1" />
          <div v-if="detailValidation('P1_')" class="error-message">
            {{ detailValidationText('P1_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p4">Вгорі праворуч</label>
          <input id="p4" :class="{ 'red': detailValidation('P4_') }" @change="fixedLength(detail, 'p4')"
            v-model.number="detail.p4" />
          <div v-if="detailValidation('P4_')" class="error-message">
            {{ detailValidationText('P4_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p2">Знизу ліворуч</label>
          <input id="p2" :class="{ 'red': detailValidation('P2_') }" @change="fixedLength(detail, 'p2')"
            v-model.number="detail.p2" />
          <div v-if="detailValidation('P2_')" class="error-message">
            {{ detailValidationText('P2_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p3">Знизу праворуч</label>
          <input id="p3" :class="{ 'red': detailValidation('P3_') }" @change="fixedLength(detail, 'p3')"
            v-model.number="detail.p3" />
          <div v-if="detailValidation('P3_')" class="error-message">
            {{ detailValidationText('P3_') }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-section-full">


      <div class="input-group">
        <label for="edge_template">Оклеювання кромкою</label>
        <select id="edge_template" class="custom-select edge" :style="getEdgeSelectStyle(detail.edge_template)"
          :class="{ 'red': detailValidation('EdgeA1_') }" v-model="detail.edge_template">
          <option :value="null">Ні</option>
          <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
            {{ (i + 1) + ' ' }} {{ edge.full_name }}
          </option>
        </select>
        <div v-if="detailValidation('EdgeA1_')" class="error-message">
          {{ detailValidationText('EdgeA1_') }}
        </div>
      </div>

      <div class="input-group">
        <label for="note">Примітка</label>
        <input id="note" v-model="detail.note" placeholder="Введіть примітку..." />
      </div>
    </div>
  </div>
</template>

<script>
import validation from "@/mixins/BaseTemplate"

export default {
  mixins: [validation],
  props: [
    'edges',
    'detail'
  ],
  computed: {
    resp() {
      return this.$store.state.data.response;
    },
  },
  watch: {
    detail: function (newValue, oldValue) {
      this.$root.$emit('update-detail', this.detail);
    }
  },
  methods: {
    getEdgeSelectStyle(edgeRef) {
      const edge = this.edges.find(m => m.ref === edgeRef);
      if (edge && edge.color) {
        const contrastColor = this.getContrastColor(edge.color);
        return {
          backgroundColor: edge.color,
          color: contrastColor,
          borderColor: contrastColor,
        };
      }
      return {};
    },

    // Метод для получения контрастного цвета
    getContrastColor(hexColor) {
      if (!hexColor) return '#000000';

      // Убираем # если есть
      const hex = hexColor.replace('#', '');

      // Конвертируем в RGB
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Вычисляем яркость
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Возвращаем белый для темных цветов, черный для светлых
      return brightness > 128 ? '#000000' : '#ffffff';
    }
  },
  name: "Template_3"
}
</script>


<style scoped>
/* All styles moved to src/assets/scss/general/templates.scss */
</style>